module.exports = __webpack_public_path__ + "img/commission_icon.c0f5f150.png";